module.exports = __webpack_public_path__ + "static/media/occupation-min.ecc88ee3.jpg";